import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemEdgeEffectsOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-edge-effects-option';
import {EdgeType} from '@PosterWhiteboard/classes/item-effects.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemEdgeEffectsOption(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const edgeType = useGetKeyFromEffectsActiveItem('edgeType');
  const edgeThickness = useGetKeyFromEffectsActiveItem('edgeThickness');

  if (activeItem?.isImage() && activeItem.isDrawing()) {
    return null;
  }

  if (!activeItem || (activeItem && !('effects' in activeItem)) || edgeType === undefined || edgeThickness === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const applyEffect = (valueToApply: EdgeType): void => {
    if (edgeType === valueToApply) {
      return;
    }

    void activeItem.updateFromObject({
      effects: {
        edgeType: valueToApply,
      },
      border: {
        solidBorderType: activeItem.effects.getBorderForEdgeEffect(valueToApply),
      },
    });

    if (valueToApply === EdgeType.CURVED || valueToApply === EdgeType.GRADIENT) {
      const thickness = valueToApply === EdgeType.CURVED ? 7 : 4;
      void activeItem.updateFromObject(
        {
          effects: {
            edgeThickness: thickness,
          },
        },
        {undoable: false}
      );
    }
  };

  const onChangeEdgeThickness = (edgeThickness: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          edgeThickness,
        },
      },
      {undoable}
    );
  };

  return (
    <BaseItemEdgeEffectsOption
      edgeType={edgeType}
      edgeThickness={edgeThickness}
      applyEffect={applyEffect}
      onChangeThickness={onChangeEdgeThickness}
      showCurvedEffect={!activeItem.isVideo()}
    />
  );
}
